module.exports = __webpack_public_path__ + "static/media/BikeSharing-design.0135f01b.pdf";